import { gql, useMutation } from '@apollo/client';

import type {
  StartDependentPhoneVerificationMutation,
  StartDependentPhoneVerificationMutationVariables,
} from './__generated__/useStartDependentPhoneVerification.gql';

const START_DEPENDENT_PHONE_VERIFICATION = gql`
  mutation StartDependentPhoneVerification($input: StartDependentPhoneVerificationInput!) {
    startDependentPhoneVerification(input: $input) {
      id
      phoneNumberVerifiedAt
      phoneVerificationStartedAt
    }
  }
`;

/**
 * Open the group text that proves a loved one holds the number on file.
 *
 * Takes only their id: the number and the address are the household's record,
 * and a caregiver corrects each through its own field. One button that both
 * changed a number and texted it would send a stranger a message about this
 * family on a typo.
 *
 * `phoneVerificationStartedAt` is selected because the write is what sets it —
 * Apollo merges the response into the existing `Dependant:<id>` record, so the
 * card moves from offering the verification to reporting it without a refetch.
 *
 * @returns The standard `useMutation` tuple — `[mutate, MutationResult]`.
 */
export const useStartDependentPhoneVerification = () => {
  return useMutation<StartDependentPhoneVerificationMutation, StartDependentPhoneVerificationMutationVariables>(
    START_DEPENDENT_PHONE_VERIFICATION
  );
};
